export class ExecuteRequestResponse {
  key: string;
  
  /**
   * ConvertReplacerなど、画面のないモジュールをサーバ側で処理ししたときはここに結果が入ってくる？
   */
  result: any;
}
